import { render, staticRenderFns } from "./StudyDetail.vue?vue&type=template&id=6ad44d6c&scoped=true"
import script from "./StudyDetail.vue?vue&type=script&lang=js"
export * from "./StudyDetail.vue?vue&type=script&lang=js"
import style0 from "./StudyDetail.vue?vue&type=style&index=0&id=6ad44d6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad44d6c",
  null
  
)

export default component.exports